export class TagInformation {

  sequence!: number;
  tag!: string;
  poLine!: string;
  riser!: string;
  floor!: string;
  room!: string;
  building!: string;
  reference!: string;
  location!: string;
  size!: boolean;
  voltage!: boolean;
  poNum!: boolean;
  projName!: boolean;
  noTag!: boolean;

}
